import { config } from "./domainConfig";
import { isGameverselt } from "./productCondition";

// Categories that must be visible only on portal.gameverse-lt.com
const gameversePortalOnlyCategories = ["Grand Theft Auto"];
const isGameversePortal = config.subDomain === "portal" && isGameverselt;

export const isCategoryAllowed = (categoryName) =>
  isGameversePortal || !gameversePortalOnlyCategories.includes(categoryName);



// WEBPACK FOOTER //
// ./src/constants/restrictedCategories.js